import {Get} from "./request";
import {generateAppRoutes, getRoute} from "../breadcrumb/utils";
import routes from "../routes";
import screens from "../screens";
import {isEmpty, isNumber, isString} from 'lodash';
import {matchPath} from "react-router-dom";
import img from "../static/img";

let firstPath = process.env.APP_ROOT;
let firstAccesReinscription = true;
let limitAccesReinscription = false;
let printReleveNotes = true;
let screenAccessInitialized = false;
let authenticationInProgress = false;
let currentUser = null;
let screenAccess = [];
let appRoutes = [];
let notifications = [];
let version = {apiVersion: "", meteorVersion: ""};

const isInit = () => {
    return authenticationInProgress === false && screenAccessInitialized === true;
};

const isAuthenticated = () => {
    return currentUser !== null;
};

const waitForInit = async (callback, withInit = false) => {
    if (isInit() === true) return callback();

    if (withInit === true) getAPIAuthentication();

    if (callback) {
        setTimeout(() => {
            if (isInit() !== true) {
                waitForInit(callback);
            } else {
                callback();
            }
        }, 200);
    }
};

const initScreenAccess = async () => {
    try {
        const {body} = await Get('/v1/security/access');

        if (!body) {
            return;
        }

        appRoutes = generateAppRoutes(routes);

        body.forEach(item => {
            if (!item) {
                return;
            }

            const route = appRoutes.find(f => f.screen === item.ScreenLocation);

            const pageOption = {
                pathname: route ? route.path : null,
                screenLocation: item.ScreenLocation,
                canCreate: item.Create === true,
                canAccess: item.Read === true,
                canUpdate: item.Update === true,
                canDelete: item.Delete === true
            };

            screenAccess.push(pageOption);
        });

        await checkEventAccess();

        await checkNotifications();

        screenAccessInitialized = true;
    } catch (ex) {
        console.log(ex);
    }
};

const allowPage = (numPage) => {
    screenAccess.find(f => f.screenLocation === numPage).canAccess = true;
};

const denyPage = (numPage) => {
    screenAccess.find(f => f.screenLocation === numPage).canAccess = false;
};

const denyUpdate = (numPage) => {
    screenAccess.find(f => f.screenLocation === numPage).canUpdate = false;
};

const checkEventAccess = async () => {
    try {
        const {body} = await Get(`/v1/events/access`);

        firstAccesReinscription = JSON.parse(body.FirstAccesReinscription);
        limitAccesReinscription = JSON.parse(body.LimitAccesReinscription);
        printReleveNotes = JSON.parse(body.CanPrintReleveNotes);

        if (body.AccesCommande !== true) {
            denyPage(screens.NouvelleCommande);
        }

        if (body.CanViewInscriptionSession !== true) {
            denyPage(screens.Examens);
        }

        if (body.HasMemoire !== true) {
            denyPage(screens.Memoire);
            denyPage(screens.RemiseMemoire);
            denyPage(screens.InformationsRelativesDefenseMemoire);
        } else {
            if (body.AccesMemoireTitre !== true) {
                denyUpdate(screens.Memoire);
            }

            if (body.AccesMemoireRemise !== true) {
                denyPage(screens.RemiseMemoire);
            }

            if (body.AccesIDM !== true) {
                denyPage(screens.InformationsRelativesDefenseMemoire);
            }
        }

        if (body.CanViewStage !== true) {
            denyPage(screens.Stages);
        }

        if (body.AccesReinscription !== true) {
            denyPage(screens.Reinscription);
            denyPage(screens.PAE);
        }

        if (body.AccesSignaturePAE !== true) {
            denyPage(screens.SignaturePAE);
        }

        if (body.AccesSignaturePAI !== true) {
            denyPage(screens.SignaturePAI);
        }

        if (body.AccesInscriptionTP !== true) {
            denyPage(screens.InscriptionTP);
        }

        if (body.AccesProclamation !== true) {
            denyPage(screens.Proclamation);
        }

        if (currentUser.ICHECVerifications === true) {
            allowPage(screens.Verifications);
        }

    } catch (e) {
        denyPage(screens.NouvelleCommande);
        denyPage(screens.Commandes);
        denyPage(screens.Examens);
        denyPage(screens.Memoire);
        denyPage(screens.RemiseMemoire);
        denyPage(screens.Stages);
        denyPage(screens.Reinscription);
        denyPage(screens.SignaturePAE);
        denyPage(screens.SignaturePAI);
        denyPage(screens.InscriptionTP);
        denyPage(screens.InformationsRelativesDefenseMemoire);
        denyPage(screens.Proclamation);
    }
};

const checkNotifications = async () => {
    try {
        const {body} = await Get(`/v1/extranet/student/${screens.Documents}`);

        notifications['nbDocuments'] = body.length;

    } catch (e) {
        console.log(e);
    }
};

const renderEvenements = () => {

    let events = [];

    if (canAccess(screens.Stages)[0]) {
        events.push({
            name: "Mes stages",
            onClick: getRoute(screens.Stages),
            img: img.Stage
        });
    }

    if (canAccess(screens.Memoire)[0]) {
        events.push({
            name: "Mon mémoire",
            onClick: getRoute(screens.Memoire),
            img: img.Memoire
        });
    }

    if (canAccess(screens.Examens)[0]) {
        events.push({
            name: "Inscription à la session d'examens",
            onClick: getRoute(screens.Examens),
            img: img.Inscription
        });
    }

    if (canAccess(screens.Reinscription)[0]) {
        events.push({
            name: "Réinscription",
            onClick: getRoute(screens.Reinscription),
            img: img.Reinscription
        });
    }

    if (canAccess(screens.SignaturePAE)[0]) {
        events.push({
            name: "Signature de mon programme annuel",
            onClick: getRoute(screens.SignaturePAE),
            img: img.SignaturePAE
        });
    }

    if (canAccess(screens.InscriptionTP)[0] && process.env.APP_DEPARTEMENT !== "ISFSC") {
        events.push({
            name: "Inscription aux TP",
            onClick: getRoute(screens.InscriptionTP),
            img: img.Inscription
        });
    }
    
    if (canAccess(screens.Proclamation)[0]) {
        events.push({
            name: "Proclamation",
            onClick: getRoute(screens.Proclamation),
            img: img.Proclamation
        });
    }    

    // Temporarily deactivate with   if (1 === 0 && currentUser.isBac1) {
    if (currentUser.isBac1) {
        events.push({
            name: "Service d'aide à la réussite",
            onClick: getRoute(screens.SAR),
            img: img.SAR
        });
    }

    return events;
};

const getNotifications = () => {
    return notifications;
};

const getAPIAuthentication = async () => {
    if (authenticationInProgress === true) return;

    authenticationInProgress = true;

    try {
        let {body} = await Get(`/v1/security/status`);

        if (!body) return;

        currentUser = body;

        ({body} = await Get(`/v1/version`));

        if (body === undefined || body === null) {
            return;
        }

        version.apiVersion = body.apiVersion;
        version.meteorVersion = body.meteorVersion;

        ({body} = await Get(`/v1/security/infos`));

        if (body === undefined || body === null) {
            return;
        }

        currentUser.isActive = body.isActive;
        currentUser.isBlocked = body.isBlocked;
        currentUser.isRGPD = body.isRGPD;

        ({body} = await Get(`/v1/extranet/student/${screens.Dashboard}`));
        currentUser.DisplayName = `${body.PersonnePrenom} ${body.PersonneNom}`;
        currentUser.Coordinateurs = body.Coordinateurs;
        currentUser.GestionnairesAdministratifs = body.GestionnairesAdministratifs;
        currentUser.isBac1 = body.NiveauCoursLibelle ? body.NiveauCoursLibelle.includes("1ère") : false;

        if (currentUser.ICHECAdmin === true || currentUser.ICHECProgrammes === true) {
            currentUser.EtudiantMatricule = body.EtudiantMatricule;
        } else {
            currentUser.EtudiantMatricule = currentUser.Username.replace("ICHEC\\", "");
        }

        await initScreenAccess();
    } catch (xhr) {
        console.log(xhr);
    } finally {
        authenticationInProgress = false;
    }
};

const getUser = (callback) => {
    if (callback) {
        setTimeout(() => {
            if (authenticationInProgress === true) {
                getUser(callback);
            } else {
                callback(currentUser);
            }
        }, 200);
    } else {
        return currentUser;
    }
};

const getFirstAccesReinscription = () => {
    return firstAccesReinscription;
}

const getLimitAccesReinscription = () => {
    return limitAccesReinscription;
}

const getAppRoutes = () => {
    return appRoutes;
}

const canPrintReleveNotes = () => {
    return printReleveNotes;
}

const canAccessByPathname = (screen) => {
    let result = false;

    if (!isEmpty(screenAccess)) {
        result = screenAccess.find(f => matchPath(screen, {path: f.pathname, exact: true}));
        if (!result) {
            result = screenAccess.find(f => matchPath(screen, {path: f.pathname})).canAccess;
        } else {
            result = result.canAccess;
        }
    }

    return result;
};

const canAccessByScreenLocation = (screen) => {
    return !isEmpty(screenAccess) && screenAccess.find(f => f.screenLocation === screen).canAccess;
};

const canAccess = (screen) => {
    if (currentUser
        && currentUser.ICHECEtudiant === false
        && currentUser.ICHECAdmin === false
        && currentUser.ICHECVerifications === false
        && currentUser.ICHECProgrammes === false) {
        return [false, process.env.APP_ROOT + 'notStudent'];
    } else if (currentUser && currentUser.isActive === false) {
        return [false, process.env.APP_ROOT + 'inactiveStudent'];
    } else if (currentUser && currentUser.isBlocked !== false && isString(screen) && screen !== process.env.APP_ROOT + 'documents' && screen !== process.env.APP_ROOT + 'valves') {
        return [false, process.env.APP_ROOT + 'blockedStudent'];
    } else if (isString(screen)) {
        return [canAccessByPathname(screen), process.env.APP_ROOT + 'forbidden'];
    } else if (isNumber(screen)) {
        return [canAccessByScreenLocation(screen), process.env.APP_ROOT + 'forbidden'];
    } else {
        return [false, process.env.APP_ROOT + 'forbidden'];
    }
};

const findAccess = (screen) => {
    if (!isEmpty(screenAccess)) {
        if (isString(screen)) {
            let find = screenAccess.find(f => matchPath(screen, {path: f.pathname, exact: true}));

            if (!find) {
                return screenAccess.find(f => matchPath(screen, {path: f.pathname}));
            } else {
                return find;
            }
        } else if (isNumber(screen)) {
            return screenAccess.find(f => f.screenLocation === screen);
        }
    }

    return {
        pathname: null,
        screenLocation: -1,
        canCreate: false,
        canAccess: false,
        canUpdate: false,
        canDelete: false
    };
};

export default {
    firstPath,
    firstAccesReinscription,
    denyPage,
    getFirstAccesReinscription,
    getLimitAccesReinscription,
    getAppRoutes,
    canPrintReleveNotes,
    waitForInit,
    getUser,
    isInit,
    isAuthenticated,
    canAccess,
    findAccess,
    renderEvenements,
    getNotifications,
    version
};